import React from 'react';
import offlineicon from "../../assets/images/icons/wifi-slash.png";

const OffLineBanner = () => {

    return (
        <div id={'banner-offline'}>
            <img className={'icon-offline'} src={offlineicon} alt={"Pas de connexion"}/>
            Actuellement, Hors Ligne.
            <div className={'small-text-center-light'}>
                Le fonctionnement peut être limité
            </div>
        </div>
    );
};

export default OffLineBanner;